@if (isLogged()) {
  @if (isEmployeeRoute()) {
    <router-outlet></router-outlet>
  } @else {
  @if (isDesktop() && showShellNavigation()) {
    <aside class="sidebar"
      [class.collapsed]="isSidebarCollapsed()"
      (mouseenter)="openFlyout()"
      (mouseleave)="scheduleFlyoutClose()">
      @if (!isSidebarCollapsed()) {
        <div class="sidebar-inner tw:overflow-y-auto">
          <div class="brand-row tw:flex tw:items-center">
            <div class="brand-mark tw:grid">U</div>
            <div class="brand-copy">
              <h1>Urakka</h1>
              <p>FieldOS</p>
            </div>
          </div>

          @if (!isSuperAdmin()) {
            <div class="sidebar-search-wrap">
              <input #sidebarSearchInput
                class="sidebar-search"
                type="search"
                [placeholder]="'general.searchItems' | translate"
                [value]="quickFinderQuery()"
                (input)="onQuickFinderInput($any($event.target).value)"
                (keydown)="onQuickFinderKeydown($event)" />

              @if (showQuickFinder()) {
                <div class="quick-finder-panel tw:fixed tw:overflow-auto">
                  <div class="quick-finder-head tw:flex tw:justify-between">
                    <p>{{ 'shell.quickFinder.title' | translate }}</p>
                    <small>{{ 'shell.quickFinder.subtitle' | translate }}</small>
                  </div>

                  @for (group of quickFinderGroups(); track group.categoryKey) {
                    <section class="quick-finder-group">
                      <h5>{{ group.categoryKey | translate }}</h5>
                      @for (item of group.items; track item.id) {
                        <a class="quick-finder-item tw:flex tw:items-center tw:justify-between"
                          [class.active]="isQuickFinderItemActive(item)"
                          [attr.href]="item.href"
                          (mouseenter)="activeQuickFinderIndex.set(quickFinderFlatResults().indexOf(item))"
                          (click)="openFinderItem(item, $event)">
                          <ng-container [ngTemplateOutlet]="finderItemMeta"
                            [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
                        </a>
                      }
                    </section>
                  }
                </div>
              }
            </div>

          }

          @for (group of navigationModules(); track group.title) {
            <section class="module">
              @if (group.title) {
                <h4>{{ group.title | translate | uppercase }}</h4>
              }
              @for (item of group.items; track item.label) {
                <button class="module-item tw:w-full tw:text-left tw:cursor-pointer tw:block"
                  [class.active]="item.isActive"
                  [routerLink]="item.route"
                  [queryParams]="item.queryParams || null"
                  type="button">
                  {{ item.label | translate }}
                </button>
              }
            </section>
          }
        </div>
      }

      @if (isSidebarCollapsed()) {
        <div class="rail-zone tw:relative tw:h-full tw:overflow-visible">
          <div class="rail tw:relative tw:flex-col tw:items-center">
            <div class="rail-logo tw:cursor-pointer"
              aria-hidden="true">U</div>
          </div>

          @if (isFlyoutOpen()) {
            <div class="sidebar-flyout tw:overflow-auto">
              <div class="flyout-head tw:items-center">
                <div class="brand-mark tw:grid">U</div>
                <div>
                  <strong>Urakka.app</strong>
                  <small>FieldOS</small>
                </div>
              </div>

              @for (group of navigationModules(); track group.title) {
                <section class="module compact">
                  @if (group.title) {
                    <h4>{{ group.title | translate | uppercase }}</h4>
                  }
                  @for (item of group.items; track item.label) {
                    <button class="module-item tw:w-full tw:text-left tw:cursor-pointer tw:block"
                      [class.active]="item.isActive"
                      [routerLink]="item.route"
                      [queryParams]="item.queryParams || null"
                      type="button">
                      {{ item.label | translate }}
                    </button>
                  }
                </section>
              }
            </div>
          }
        </div>
      }

      <button class="sidebar-toggle tw:cursor-pointer"
        type="button"
        (click)="toggleSidebar()"
        aria-label="Toggle sidebar">
        {{ isSidebarCollapsed() ? '›' : '‹' }}
      </button>
    </aside>
  }

  <ion-content [fullscreen]="true">

    <div class="shell-root tw:overflow-visible"
      [class.shell-desktop]="isDesktop()"
      [class.shell-mobile]="!isDesktop()"
      [class.no-sidebar]="!showShellNavigation()"
      [class.sidebar-collapsed]="isSidebarCollapsed()">
      @if (!isDesktop()) {
        <header class="mobile-topbar tw:sticky tw:flex tw:items-center tw:justify-between">
          <app-user-simulation></app-user-simulation>
          <app-test-data></app-test-data>
          @if (showShellNavigation()) {
            <button class="icon-button"
              type="button"
              (click)="toggleDrawer()"
              aria-label="Open navigation">☰</button>
          } @else {
            <div></div>
          }
          <div class="mobile-brand">
            <div class="eyebrow">{{ 'nav-item.operational.title' | translate }}</div>
            <h2>Urakka.app</h2>
          </div>
          <div class="mobile-avatar tw:grid"
            (click)="onProfile()">{{ userInitials() }}
          </div>
        </header>
      }

      @if (!isDesktop() && showShellNavigation() && isDrawerOpen()) {
        <div class="drawer-backdrop tw:fixed"
          (click)="closeDrawer()"></div>
      }

      @if (!isDesktop() && showShellNavigation()) {
        <aside class="mobile-drawer tw:fixed"
          [class.open]="isDrawerOpen()">
          <div class="drawer-head tw:flex tw:justify-between tw:items-center">
            <div class="drawer-brand tw:items-center">
              <div class="brand-mark tw:grid">U</div>
              <div>
                <strong>Urakka.app</strong>
                <small>FieldOS</small>
              </div>
            </div>
            <button class="icon-button"
              type="button"
              (click)="closeDrawer()"
              aria-label="Close navigation">✕</button>
          </div>

          <nav class="drawer-nav">
            @for (item of navItems(); track $index) {
              <a [routerLink]="item.route"
                [queryParams]="item.queryParams || null"
                [class.active]="item.isActive"
                [ngClass]="item.cssClass ?? []"
                class="drawer-link tw:block"
                (click)="closeDrawer()">
                {{ item.label | translate }}
              </a>
            }
          </nav>
        </aside>
      }

      <div class="layout-body tw:grid tw:overflow-visible">
        <section class="main-area tw:min-w-0 tw:overflow-visible tw:flex tw:flex-col">
          @if (isDesktop()) {
            <header class="global-topbar tw:items-center tw:justify-between">
              <app-user-simulation></app-user-simulation>
              <app-test-data></app-test-data>
              <div class="global-topbar__spacer"></div>

              <div class="global-topbar__actions tw:items-center tw:inline-flex">
                @if (isWorkerRole()) {
                  <div class="topbar-active-task-menu tw:relative"
                    #activeTaskMenuContainer>
                    <button class="topbar-icon-button topbar-active-task-trigger tw:items-center tw:cursor-pointer tw:inline-flex tw:justify-center"
                      type="button"
                      [class.topbar-icon-button-active]="isActiveTaskMenuOpen()"
                      [attr.aria-expanded]="isActiveTaskMenuOpen()"
                      [attr.aria-label]="'workerUi.task.live.headerAria' | translate"
                      (click)="toggleActiveTaskMenu($event)">
                      <span class="topbar-active-task-trigger__ring tw:inline-flex tw:items-center tw:justify-center">
                        <ion-icon name="radio-button-on-outline"></ion-icon>
                      </span>
                      @if (activeTaskVm(); as activeTask) {
                        <span class="topbar-active-task-trigger__time tw:whitespace-nowrap">{{ activeTask.iconElapsedLabel }}</span>
                      }
                    </button>

                    @if (isActiveTaskMenuOpen()) {
                      <section class="topbar-active-task-panel tw:absolute"
                        (click)="$event.stopPropagation()">
                        <header class="topbar-active-task-panel__header tw:items-center">
                          <h3>{{ 'workerUi.task.live.panelTitle' | translate }}</h3>
                          <button type="button"
                            (click)="closeActiveTaskMenu()">
                            <ion-icon name="close-outline"></ion-icon>
                          </button>
                        </header>

                        @if (activeTaskVm(); as activeTask) {
                          <div class="topbar-active-task-panel__body tw:grid">
                            <strong>{{ activeTask.title }}</strong>
                            @if (activeTask.location) {
                              <p>{{ activeTask.location }}</p>
                            }
                            <div class="topbar-active-task-panel__status tw:inline-flex tw:items-center">
                              <span class="topbar-active-task-panel__live-dot tw:bg-app-success"
                                aria-hidden="true"></span>
                              {{ activeTask.statusLabelKey | translate }}
                            </div>
                            <span class="topbar-active-task-panel__metric">
                              {{ 'workerUi.task.live.elapsedUsed' | translate:{ time: activeTask.elapsedLabel } }}
                            </span>
                            @if (activeTask.estimateLabel) {
                              <span class="topbar-active-task-panel__metric topbar-active-task-panel__metric-muted">
                                {{ 'workerUi.task.live.estimate' | translate:{ time: activeTask.estimateLabel } }}
                              </span>
                              <progress class="topbar-active-task-panel__progress tw:w-full tw:overflow-hidden"
                                [value]="activeTask.progressPercent ?? 0"
                                max="100"></progress>
                            }
                            <div class="topbar-active-task-panel__actions tw:flex tw:flex-wrap">
                              <button type="button"
                                (click)="onActiveTaskAction('block')">{{ 'workerUi.task.actions.block' | translate }}</button>
                              <button type="button"
                                (click)="onActiveTaskAction('pause')">{{ 'workerUi.task.actions.pause' | translate }}</button>
                              <button type="button"
                                class="topbar-active-task-panel__action-primary"
                                (click)="onActiveTaskAction('complete')">{{ 'workerUi.task.actions.complete' | translate }}</button>
                            </div>
                            <button type="button"
                              class="topbar-active-task-panel__open"
                              (click)="openActiveTaskDetail()">
                              {{ 'workerUi.task.live.openTask' | translate }}
                            </button>
                          </div>
                        } @else {
                          <p class="topbar-active-task-panel__empty tw:text-center">{{ 'workerUi.task.live.noActiveTask' | translate }}
                          </p>
                        }
                      </section>
                    }
                  </div>
                }

                <button class="topbar-icon-button tw:relative tw:items-center tw:cursor-pointer tw:inline-flex tw:justify-center"
                  type="button"
                  [attr.aria-label]="'messagesWorkspace.actions.open' | translate"
                  (click)="openMessages()">
                  <ion-icon name="chatbubble-ellipses-outline"></ion-icon><app-messages-unread-badge />
                </button>

                <div class="topbar-notification-menu tw:relative"
                  #notificationsMenuContainer>
                  <button class="topbar-icon-button tw:items-center tw:cursor-pointer tw:inline-flex tw:justify-center"
                    type="button"
                    [class.topbar-icon-button-active]="isNotificationsOpen()"
                    [attr.aria-expanded]="isNotificationsOpen()"
                    [attr.aria-label]="'messagesWorkspace.actions.notifications' | translate"
                    (click)="toggleNotifications($event)">
                    <ion-icon name="notifications-outline"></ion-icon>
                  </button>

                  @if (isNotificationsOpen()) {
                    <app-notification-popover (closeRequested)="closeNotifications()"></app-notification-popover>
                  }
                </div>

                <div class="topbar-profile-menu tw:relative"
                  #profileMenuContainer
                  [class.open]="isProfileMenuOpen()">
                  <button class="topbar-profile-trigger tw:items-center tw:cursor-pointer tw:inline-flex"
                    type="button"
                    (click)="toggleProfileMenu($event)">
                    <span class="topbar-profile-avatar tw:items-center tw:inline-flex tw:justify-center">{{ userInitials() }}</span>
                    <span class="topbar-profile-name">{{ firstName() }}</span>
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  </button>

                  @if (isProfileMenuOpen()) {
                    <div class="topbar-profile-dropdown tw:absolute tw:grid"
                      (click)="$event.stopPropagation()">
                      <div class="topbar-profile-dropdown__identity tw:grid">
                        <strong>{{ fullName() }}</strong>
                        <span>{{ email() }}</span>
                      </div>
                      <div class="topbar-profile-dropdown__divider"></div>
                      <button type="button"
                        (click)="goToProfile()">{{ 'profileWorkspace.title' | translate }}</button>
                      <button type="button"
                        (click)="logout()">{{ 'logout.title' | translate }}</button>
                    </div>
                  }
                </div>
              </div>
            </header>
          }

          <div class="view-container tw:relative tw:overflow-visible">
            <router-outlet></router-outlet>
          </div>
        </section>
      </div>
    </div>

    @if (!isDesktop() && showShellNavigation() && !hideFab() && isFabMenuOpen()) {
      <button class="fab-backdrop tw:pointer-events-auto"
        type="button"
        (click)="closeFabMenu()"
        [attr.aria-label]="'shell.fab.toggleQuickActions' | translate"></button>
    }

    @if (showShellNavigation() && !hideFab()) {
      @if (!isDesktop()) {
        <div class="fab-shell fab-shell-mobile tw:grid"
          slot="fixed"
          #fabContainer>
          @if (isFabMenuOpen()) {
            <section class="fab-panel tw:overflow-hidden tw:pointer-events-auto"
              (click)="$event.stopPropagation()">
              @for (action of visibleFabActions(); track $index) {
                <button class="fab-panel-item tw:flex tw:items-center tw:text-left"
                  type="button"
                  (click)="onFabAction(action)">
                  @if (action.icon) {
                    <ion-icon [name]="action.icon"></ion-icon>
                  }
                  <span>{{ action.labelKey | translate }}</span>
                </button>
              }
            </section>
          }

          <button class="fab"
            type="button"
            (click)="toggleFabMenu()"
            [attr.aria-label]="'shell.fab.toggleQuickActions' | translate">
            {{ isFabMenuOpen() ? '×' : '+' }}
          </button>
        </div>
      } @else {
        <div class="fab-shell tw:grid"
          slot="fixed"
          #fabContainer>
          <div class="fab-menu tw:grid"
            [class.open]="isFabMenuOpen()">
            @for (action of visibleFabActions(); track $index) {
              <button class="fab-item tw:text-left tw:cursor-pointer tw:inline-flex tw:items-center"
                type="button"
                (click)="onFabAction(action)">
                @if (action.icon) {
                  <ion-icon [name]="action.icon"></ion-icon>
                }
                <span>{{ action.labelKey | translate }}</span>
              </button>
            }
          </div>

          <button class="fab"
            type="button"
            (click)="toggleFabMenu()"
            [attr.aria-label]="'shell.fab.toggleQuickActions' | translate">
            {{ isFabMenuOpen() ? '×' : '+' }}
          </button>
        </div>
      }
    }

    @if (!isSuperAdmin() && isCommandPaletteOpen()) {
      <div class="command-palette-backdrop tw:fixed"
        (click)="closeCommandPalette()"></div>
      <section class="command-palette tw:fixed">
        <div class="command-palette-head tw:justify-between">
          <p>{{ 'shell.commandPalette.title' | translate }}</p>
          <small>Cmd+K / Ctrl+K</small>
        </div>
        <input #commandPaletteInput
          class="command-palette-input"
          type="search"
          [placeholder]="'shell.commandPalette.placeholder' | translate"
          [value]="commandPaletteQuery()"
          (input)="onCommandPaletteInput($any($event.target).value)"
          (keydown)="onCommandPaletteKeydown($event)" />
        <div class="command-palette-results">
          @for (group of commandPaletteGroups(); track group.categoryKey) {
            <section class="quick-finder-group">
              <h5>{{ group.categoryKey | translate }}</h5>
              @for (item of group.items; track item.id) {
                <a class="quick-finder-item tw:flex tw:items-center tw:justify-between"
                  [class.active]="isCommandPaletteItemActive(item)"
                  [attr.href]="item.href"
                  (mouseenter)="activeCommandPaletteIndex.set(commandPaletteFlatResults().indexOf(item))"
                  (click)="openFinderItem(item, $event)">
                  <ng-container [ngTemplateOutlet]="finderItemMeta"
                    [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
                </a>
              }
            </section>
          }
        </div>
      </section>
    }

    <ng-template #finderItemMeta
      let-item>
      <span>{{ item.label }}</span>
      @if (item.type === 'task') {
        <small>
          {{ item.subLabel ?? '-' }} · {{ item.areaLabel ?? '-' }} ·
          @if (item.taskStatus) {
            {{ ('kanban.status.' + item.taskStatus) | translate }}
          } @else {
            -
          }
        </small>
      } @else {
        <small>{{ item.categoryKey | translate }}</small>
      }
    </ng-template>
  </ion-content>
  }
} @else {
  <ion-router-outlet class="not-logged"></ion-router-outlet>
}
